<template>
  <div class="password-hint">
    <div class="hint-title">Password must contain:</div>
    <div class="hint-criteria">
      <div 
        v-for="criterion in criteria" 
        :key="criterion.id"
        class="criterion"
        :class="{ 'matched': criterion.matched }"
      >
        <span class="criterion-icon">
          <i :class="criterion.matched ? 'icon-check' : 'icon-close'"></i>
        </span>
        <span class="criterion-text">{{ criterion.text }}</span>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'PasswordHint',
  props: {
    password: {
      type: String,
      default: '',
    },
  },
  computed: {
    criteria() {
      return [
        {
          id: 'lowercase',
          text: 'At least one lowercase letter',
          matched: /[a-z]/.test(this.password),
        },
        {
          id: 'uppercase',
          text: 'At least one uppercase letter',
          matched: /[A-Z]/.test(this.password),
        },
        {
          id: 'number',
          text: 'At least one number',
          matched: /[0-9]/.test(this.password),
        },
        {
          id: 'special',
          text: 'At least one special character',
          matched: /[!@#$%^&*()_+\-=[\]{};':"\\|,.<>/?]/.test(this.password),
        },
        {
          id: 'length',
          text: 'Minimum of 8 characters',
          matched: this.password.length >= 8,
        },
      ];
    },
  },
};
</script>

<style scoped>
.password-hint {
  margin-top: 10px;
  margin-bottom: 15px;
  padding: 10px;
  background-color: #f9f9f9;
  border-radius: 4px;
  border: 1px solid #ddd;
}

.hint-title {
  font-size: 16px;
  font-weight: bold;
  color: #666;
  margin-bottom: 8px;
}

.hint-criteria {
  display: flex;
  flex-direction: column;
  gap: 4px;
}

.criterion {
  display: flex;
  align-items: center;
  font-size: 11px;
  color: #999;
  transition: color 0.2s ease;
}

.criterion.matched {
  color: #5cb85c;
}

.criterion-icon {
  margin-right: 6px;
  width: 12px;
  text-align: center;
}

.criterion-icon i {
  font-size: 12px;
}

.criterion.matched .criterion-icon i {
  color: #5cb85c;
}

.criterion:not(.matched) .criterion-icon i {
  color: #d9534f;
}

.criterion-text {
  flex: 1;
  text-align: left;
  font-size: 14px;
  font-weight: 500;
}
</style> 


// WEBPACK FOOTER //
// PasswordHint.vue?75e8a788